import revive_payload_client_4sVQNw7RlN from "/srv/sites/cryptoxchange/cryptoxchange-nuxt/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/srv/sites/cryptoxchange/cryptoxchange-nuxt/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/srv/sites/cryptoxchange/cryptoxchange-nuxt/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/srv/sites/cryptoxchange/cryptoxchange-nuxt/node_modules/nuxt/dist/app/plugins/payload.client.js";
import components_plugin_KR1HBZs4kY from "/srv/sites/cryptoxchange/cryptoxchange-nuxt/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/srv/sites/cryptoxchange/cryptoxchange-nuxt/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import colors_244lXBzhnM from "/srv/sites/cryptoxchange/cryptoxchange-nuxt/node_modules/@nuxt/ui/dist/runtime/plugins/colors.mjs";
import plugin_client_i8AMfKeYnY from "/srv/sites/cryptoxchange/cryptoxchange-nuxt/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.mjs";
import chunk_reload_client_UciE0i6zes from "/srv/sites/cryptoxchange/cryptoxchange-nuxt/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/srv/sites/cryptoxchange/cryptoxchange-nuxt/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  colors_244lXBzhnM,
  plugin_client_i8AMfKeYnY,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ
]